module.exports = __webpack_public_path__ + "static/img/wd3.1ae9105.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/workimg/wd3.png
// module id = Nlcf
// module chunks = 5